export const getPercentageClassName = ({ over }: { over: boolean }) =>
  over ? 'text-content-alert-default' : 'text-content-secondary-bg-primary';

export const Percentage = ({ ratio }: { ratio: number }) => {
  if (!Number.isFinite(ratio) || ratio < 0) {
    return null;
  }
  const percentage = Math.ceil(ratio * 100);
  return <>{percentage}%</>;
};
